export default {
  SET_USER_DETAILS(state, payload) {
    state.brainedUserDetails = payload;
  },

  SET_PROJECT(state, payload) {
    state[payload.key] = payload.value;
  },

  SET_LATEST_MILESTONE(state, payload) {
    state.latestMilestone = payload;
  },

  SET_USERS(state, payload) {
    state[payload.key] = payload.value;
  },

  SET_VERSIONS(state, payload) {
    state.versions = payload;
  },
  SET_LATEST_VERSIONS(state, payload) {
    state.latestVersion = payload;
  },
  // USER_MODULES(state, payload) {
  //   state[payload.key] = payload.value;
  // },
  // USER_ROLES(state, payload) {
  //   state[payload.key] = payload.value;
  // },
  // SET_PLAN(state, payload) {
  //   state[payload.key] = payload.value;
  // },
};
